import { render } from "./RegistrationQuoteComponent.vue?vue&type=template&id=2ee71f22"
import script from "./RegistrationQuoteComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationQuoteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__